export const http_helper = () => {
    const customFetch = (endpoint, options) => {
        const defaultHeader = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        const controller = new AbortController();
        options.signal = controller.signal;

        options.method = options.method || "GET";
       
        options.headers = options.headers
            ?  options.headers 
            : defaultHeader;
        options.withCredentials = true;
        options.body = JSON.stringify(options.body) || false;
        if (!options.body) delete options.body;

        setTimeout(
            () => controller.abort(), 20000);
        return fetch(endpoint, options)
            .then((res) =>
                res.ok
                    ? res.json()
                    : Promise.reject({
                        data: [],
                        titulo: res.titulo || 'Error',
                        result: res.result || -1,
                        mensaje: res.message || "Ha ocurrido un error inesperado",
                    }),
            )
            .catch((err) => {
                console.log(JSON.stringify(err));
                return err;
            });
    };

    const get = (url, options = {}) => customFetch(url, options);

    const post = (url, options = {}) => {
        options.method = "POST";
        return customFetch(url, options);
    };

    const put = (url, options = {}) => {
        options.method = "PUT";
        return customFetch(url, options);
    };

    const patch = (url, options = {}) => {
        options.method = "PATCH";
        return customFetch(url, options);
    };

    const del = (url, options = {}) => {
        options.method = "DELETE";
        return customFetch(url, options);
    };

    return {
        get,
        post,
        put,
        patch,
        del,
    };
};
